import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lc-form-error-message',
    standalone: true,
    imports: [CommonModule],
    template: `
        @if (error) {
            <div class="error-message">
                <strong class="error-icon">! - </strong>
                {{ error }}
            </div>
        }
    `,
    styles: [
        `
            .error-message {
                @apply flex items-center gap-2 p-3 mb-4 bg-orange-50 dark:bg-orange-900/20  leading-none
                   border border-orange-200 dark:border-orange-800 rounded-md text-orange-700 dark:text-orange-400;

                .error-icon {
                    line-height: 10px;
                }
            }
        `,
    ],
})
export class FormErrorMessageComponent {
    @Input() error: string | null = null;
}
